module.exports = __webpack_public_path__ + "static/img/nmxp-lzp.ae96d4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/nmxp-lzp.png
// module id = dK4Y
// module chunks = 0